import HttpService from '../http.service';

const listClassCapacity = (date: any) => {
  return HttpService.get('v2', `class/capacity/${date}`, {}, {});
};

export {
  listClassCapacity,
};